import useResponsiveValue from "@/hooks/useResponsiveValue";
import {BREAKPOINTS} from "@/styles/themeSettings";

export default function useResponsiveValues(values) {
	const valMobile = useResponsiveValue(values[0], BREAKPOINTS.MOBILE);
	const valTablet = useResponsiveValue(values[1], BREAKPOINTS.TABLET);
	const valDesktop = useResponsiveValue(values[2], BREAKPOINTS.DESKTOP);

	return [valMobile, valTablet, valDesktop];
}